import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import { getAllContracts } from "../../../redux/contractSlice/contractSlice";

export default function ContractSelect({ setMaintenanceSchedules, maintenanceSchedules, isDisabled, contracts }) {
  const contractOptions = contracts?.map((contract) => ({
    value: contract?.id,
    label: contract?.branch?.name,
  }));

  const selectedContractOption = contractOptions?.find((option) => option.value === maintenanceSchedules.contract_id);

  const handleContractChange = (selectedOption) => {
    setMaintenanceSchedules({
      ...maintenanceSchedules,
      contract_id: selectedOption.value,
    });
  };

  return (
    <div>
      <label htmlFor="companySelect">عقد الفرع</label>
      <Select
        value={selectedContractOption || null}
        options={contractOptions || []}
        onChange={handleContractChange}
        placeholder="اختر العقد"
        isSearchable
        isDisabled={isDisabled}
        classNames={{
          control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
        }}
      />
    </div>
  );
}
